// rgba(225, 245, 255, 1)

import { makeThemedStyles } from "@qpr/client-api-base/viewcomponents/utils";
import React from "react";
import PerspectiveChip from "./PerspectiveChip";
import PerspectivePeriod from "./PerspectivePeriod";

const usePerspectiveHeaderStyles = makeThemedStyles(
  "PerspectiveHeader",
  (theme) => ({
    root: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "flex-start",
    },
  })
);

const PerspectiveHeader = (
  props: React.PropsWithChildren<{ title?: string; periodName?: string }>
) => {
  const styles = usePerspectiveHeaderStyles();
  return (
    <div className={styles.root}>
      <PerspectiveChip>{props.title}</PerspectiveChip>
      <PerspectivePeriod>{props.periodName}</PerspectivePeriod>
      {props.children}
    </div>
  );
};

export default PerspectiveHeader;
